import script from "./PopupTool8.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupTool8.vue?vue&type=script&setup=true&lang=js"

import "./PopupTool8.vue?vue&type=style&index=0&id=2abc7a5a&lang=scss&scoped=true"
import "./PopupTool8.vue?vue&type=style&index=1&id=2abc7a5a&lang=scss"

import exportComponent from "/www/wwwroot/u.xiansuotu.com/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2abc7a5a"]])

export default __exports__